import React from 'react'

import collectButtonTexture from '@assets/button-collect-small-enabled.svg?inline'
import collectButtonTextureEQ from '@assets/jackpot-eq/button-collect-small-enabled-eq.svg?inline'

import { SideButton } from '../'
import { CollectClickedMessage, GameUIMessageType } from 'game-ui-types'
import { useJackpotStore } from '@stores/jackpotStore'

interface CollectButtonProps {
    isActive: boolean
    shouldUpdateOpacityWhenInactive?: boolean
}

const CollectButton: React.FC<CollectButtonProps> = ({ isActive, shouldUpdateOpacityWhenInactive }) => {
    const isEQJackpotType = useJackpotStore((state) => state.isEQJackpotType)

    const handleClick = () => {
        const collectClickedMessage: CollectClickedMessage = { type: GameUIMessageType.COLLECT_CLICKED }

        window.postMessage(collectClickedMessage, '*')
    }

    return (
        <SideButton
            id="collect-button"
            isActive={isActive}
            onClick={handleClick}
            texture={!isEQJackpotType ? collectButtonTexture : collectButtonTextureEQ}
            shouldUpdateOpacityWhenInactive={shouldUpdateOpacityWhenInactive}
        />
    )
}

export default CollectButton
